import React, { useEffect, useState, useRef } from 'react';

function PagForm({id, ai}) {
  
  const [optionsPagamentos, setoptionsPagamentos] = useState([]); 
  const [optionsAcao, setoptionsAcao] = useState([]); 
  const [optionsSat, setoptionsSat] = useState([]); 
  const idInputRef = useRef(null); // Criando a referência
  const [imgpag, setimgpag] = useState(""); 

  useEffect(() => {
    if (idInputRef.current) {
      console.log("Referência inicializada:", idInputRef.current);
    }
  }, []);

  const handleFocus = () => {
    if (idInputRef.current) {
      idInputRef.current.focus();
    } else {
      console.log("Referência não está disponível!");
    }
  };

  const [formData, setFormData] = useState({
    id: "",
    nome: "",
    mpsat: "",
    pagamento:"",
    acao: "",
    valorminimo: "",
    valormaximo: "",
    parcelas: "",
    dias: "",
    obrigatoriocad: "",
    pededata: "",
    movparafin: "",
    quitafin: "",
    ativo: "",
    movparafinfechamento: ""
  });

  formData.codigo = id;

  const handleChange = (e) => {
  const { name, value, checked, type } = e.target; // Obtém as propriedades relevantes
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value});
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
    if (name === 'pagamento') {
      setimgpag(
        <img
          src={`img/Em${value}.bmp`}
          alt={value}
          style={{ width: '106px', height: '106px' }}
        />
      );
    }

  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const params = new URLSearchParams();
    for (const key in formData) {
      //if (key === "DataAte")  {formData[key] = DataParaDb(formData[key]); };
      if (key === "Situacao")  {
        if (formData[key] === "") {
          formData[key] = "Ativo"; }};
        //alert(key+ formData[key]);
        params.append(key, formData[key]);
    }
    console.log('params----->', params, formData);

    if (!id) {
      id = formData.id;
    }
    
    //alert( 'id '+id+'\n'+ 'ai '+ai+'\n'+    'params-----> '+ JSON.stringify(formData));
    
    //navigate("/PagGrid");
    const response = await fetch(`http://localhost:3001/cr_pag_Id/${id}/${ai}`, {
      method: "PUT",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData),
      //body: JSON.stringify({id: 1, bc: 2}),
      
    });
    if (response.status === 200) {
      //navigate(0);
      window.location.href = "./PagGrid";
    } else {
      console.error('Erro ao ATUALIZAR cliente:', response.status);
      alert('Erro ao ATUALIZAR-POST Cr_Pag.'+response.status);
    }

    console.log('data----->');
    const data = await response.json();
    alert(' >>>>>>>>>>>>>>>>>>>>>>'+data);
    
  };

  useEffect(() => {
    fetch("http://localhost:3001/cr_obj?obj=Pagamentos")
      .then((response) => { if (!response.ok) {throw new Error("Erro ao buscar os dados!");}
        return response.json();})
      .then((data) => { setoptionsPagamentos(data.cr_obj); })
      .catch((error) => console.error("Erro ao buscar os dados:", error));
  }, [id]);

  useEffect(() => {
    fetch("http://localhost:3001/cr_obj?obj=Ação")
      .then((response) => { if (!response.ok) {throw new Error("Erro ao buscar os dados!");}
        return response.json();})
      .then((data) => { setoptionsAcao(data.cr_obj); })
      .catch((error) => console.error("Erro ao buscar os dados:", error));
  }, [id]);

  useEffect(() => {
    fetch("http://localhost:3001/cr_obj?obj=Meio Pagamento SAT")
      .then((response) => { if (!response.ok) {throw new Error("Erro ao buscar os dados!");}
        return response.json();})
      .then((data) => { setoptionsSat(data.cr_obj); })
      .catch((error) => console.error("Erro ao buscar os dados:", error));
  }, [id]);

  
  useEffect(() => {
    if (ai ==="I") {
        fetch("http://localhost:3001/cr_cont?id=pag")
      .then((response) => { if (!response.ok) {throw new Error("Erro ao buscar os dados!");}
        return response.json();})
      .then((data) => { formData.id = data.cr_cont.id; 

      // alert(data.cr_cont.id);
       })
      .catch((error) => console.error("Erro ao buscar os dados:", error));
    }
  }, [id, ai, formData]);

useEffect(() => {
    fetch(`http://localhost:3001/cr_pag_Id?id=${id}`)
      .then(response => {
        if (!response.ok) {
          throw new Error("Erro ao buscar os dados!");
        }
        return response.json();
      })
      .then(data => {

        setFormData(prevState => ({ ...prevState, 
          id:data.cr_pag.id, 
          nome:data.cr_pag.nome,
          pagamento:data.cr_pag.pagamento, 
          mpsat:meipagsat(data.cr_pag.mpsat), 
          acao:data.cr_pag.acao, 
          valorminimo:data.cr_pag.valorminimo, 
          valormaximo:data.cr_pag.valormaximo, 
          parcelas:data.cr_pag.parcelas,
          dias:data.cr_pag.dias, 
          obrigatoriocad:vercheck(data.cr_pag.obrigatoriocad), 
          pededata:vercheck(data.cr_pag.pededata), 
          movparafin:vercheck(data.cr_pag.movparafin), 
          quitafin:vercheck(data.cr_pag.quitafin),
          movparafinfechamento:vercheck(data.cr_pag.movparafinfechamento),
          ativo:vercheck(data.cr_pag.ativo)
        })); 
        
      setimgpag(
            <img
              src={`img/Em${data.cr_pag.pagamento}.bmp`}
              alt={data.cr_pag.pagamento}
              style={{ width: '106px', height: '106px' }}
            />
          );
      })
      .catch(error => console.error("Erro ao buscar os dados:", error));
  }, [id, ai] );

  handleFocus();

return (
<><div class="areabox">
  <form onSubmit={handleSubmit}>
  <table class="" border={0}>
    <thead>
    <tr>
      <th>
        <label for="id" class="form-control">Código:</label><br/>  
        <input type="text" class="w15 fs1" id="id" name="id"  value={formData.id} onChange={handleChange}  />
      </th>
      <th colSpan={3}>
        <label for="nome" class="form-control ">Identificação:</label><br/>      
        <input type="text" class="w45 fs1" id="nome" name="nome" value={formData.nome} onChange={handleChange} ref={idInputRef}/>

      </th>
    </tr>
    <tr>
      <th colSpan={4}></th>
    </tr>
    <tr>
      <th colSpan={2}>
        
        <label for="pagamento" class="form-control">Pagamento:</label><br/>  
        <select class="w45 fs2" id="pagamento" name="pagamento" value={formData.pagamento} onChange={handleChange}>
        <option value=""></option>
        {Array.isArray(optionsPagamentos) && optionsPagamentos.length > 0 ? (
        optionsPagamentos.map((option, index) => (
        <option key={index} value={option.Nome}>
        {option.Nome}
        </option>
        ))
        ) : (      <option value="">Nenhum tipo disponível</option>      )}
        </select>
        <br/>
        
      </th>
      <th colSpan={2}>
      {imgpag}
      </th>
    </tr>
    <tr>
      <th colSpan={2}>
        <label for="mpsat" class="form-control">Meio de Pagamento: (Sat SP):</label><br/>  
        <select class="w45 fs2" id="mpsat" name="mpsat" value={formData.mpsat} onChange={handleChange}>
        <option value=""></option>
        {Array.isArray(optionsSat) && optionsSat.length > 0 ? (
        optionsSat.map((option, index) => (
        <option key={index} value={option.Nome}>
        {option.Nome}
        </option>
        ))
        ) : (      <option value="">Nenhum tipo disponível</option>      )}
        </select>
        <br/>

        </th>

        <th>
        <label for="acao" class="form-control">Ação:</label><br/>  
        <select class="w15 fs2" id="acao" name="acao" value={formData.acao} onChange={handleChange}>
        <option value=""></option>
        {Array.isArray(optionsAcao) && optionsAcao.length > 0 ? (
        optionsAcao.map((option, index) => (
        <option key={index} value={option.Nome}>
        {option.Nome}
        </option>
        ))
        ) : (      <option value="">Nenhum tipo disponível</option>      )}
        </select>
        <br/>
        </th>
    </tr>
    <tr>
      <th>
        <label for="valorminimo" class="form-control">Valor Mínimo:</label><br/>  
        <input type="text" id="valorminimo" name="valorminimo" value={formData.valorminimo} onChange={handleChange}/><br/>
      </th>
      <th>
      <label for="valormaximo" class="form-control">Valor Máximo:</label><br/>  
        <input type="text" id="valormaximo" name="valormaximo" value={formData.valormaximo} onChange={handleChange}/><br/>
      </th>
      <th>
        <label for="parcelas" class="form-control">Parcelas:</label><br/>  
        <input type="text" class="w15" id="parcelas" name="parcelas" value={formData.parcelas} onChange={handleChange}/><br/>
      </th>
      <th>
        
        <label for="dias" class="form-control">Direto para:</label><br/>  
        <input type="text" class="w15" id="dias" name="dias" value={formData.dias} onChange={handleChange}/>
        <label for="dias" class="form-control">(Dias)</label>
        <br/>
      </th>
    </tr>
    <tr>
      <th colSpan={4}>
        <input type="checkbox" id="obrigatoriocad"      name="obrigatoriocad"      checked={formData.obrigatoriocad} onChange={handleChange}/>
        <label for="obrigatoriocad" class="form-control">Cadastro obrigatório</label><br/>
      </th>
    </tr>
    <tr>
      <th colSpan={4}>
        <input type="checkbox" id="pededata"      name="pededata"      checked={formData.pededata} onChange={handleChange}/>
        <label for="pededata" class="form-control">Data Obrigatório</label><br/>
      </th>
    </tr>
    <tr>
      <th>
      <input type="checkbox" id="movparafin"      name="movparafin"      checked={formData.movparafin} onChange={handleChange}/>
        <label for="movparafin" class="form-control">Envia para o financeiro</label><br/>
      </th>
      <th>
        <input type="checkbox" id="quitafin"      name="quitafin"      checked={formData.quitafin} onChange={handleChange}/>
        <label for="quitafin" class="form-control">Quitado</label><br/>
      </th>
      <th colSpan={2}>
      <input type="checkbox" id="movparafinfechamento"      name="movparafinfechamento"      checked={formData.movparafinfechamento} onChange={handleChange}/>
        <label for="movparafinfechamento" class="form-control">Agrupado no Fechamento</label><br/>
      </th>
    </tr>
    <tr>
      <th colSpan={4}>
      <input type="checkbox" id="ativo"      name="ativo"      checked={formData.ativo} onChange={handleChange}/>
      <label for="ativo" class="form-control">Ativo</label><br/>
      </th>
    </tr>
    </thead>
  </table> 
  <br/>
  <button type="submit" class="botaovermelho">Confirmar</button>
  <button type="button" className="botaocinza" onClick={() => {window.location.href = "./PagGrid"; }}>Cancelar</button>&nbsp;
</form>
</div>
</>
)    
};

function vercheck(dataEntrada) {
  let dataSaida = false;
  //alert(dataEntrada);
  if (dataEntrada ==='1') {dataSaida = true};
  return (dataSaida)
};

function meipagsat(dataEntrada) {
  let dataSaida;

  switch (dataEntrada) {
    case '01':      dataSaida = 'Dinheiro';      break;
    case '02':      dataSaida = 'Cheque';      break;
    case '03':      dataSaida = 'Cartão de Crédito';      break;
    case '04':      dataSaida = 'Cartão de Débito';      break;
    case '05':      dataSaida = 'Crédito Loja';      break;
    case '10':      dataSaida = 'Vale Alimentação';      break;
    case '11':      dataSaida = 'Vale Refeição';      break;
    case '12':      dataSaida = 'Vale Presente';      break;
    case '13':      dataSaida = 'Vale Combustível';      break;
    case '99':      dataSaida = 'Outros';      break;
    default:      dataSaida = '';      break;
  }
  return dataSaida; 
}

export default PagForm;